export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Oui",
    no: "Non",
    previous: "Précédent",
    next: "Suivant",
    ok: "Valider",
    confirmation: "Confirmation",
    week: "Semaine",
    units: "{nbr} unité | {nbr} unité | {nbr} unités",
    smallWeek: "S",
    timerMessage: "Vous avez dépassé le temps imparti, veuillez réaliser l'action au plus vite !",
    wrongValue: "Valeur incorrect",
    gameFinished: "La partie est finie",
    gamePaused: "Le jeu est en pause",
    required: "requis",
    stockFrom: "Stock de",
    assemblyStock: "Stock assemblé",
    testMode: "Cette partie est en mode test. Elle ne peut être utilisée dans un but commercial."
  },
  
  instructions: {
    chooseAvatar: "Choisissez votre avatar",
    title: "Instructions",
    step: "étape",
    ready: "Je suis prêt à jouer",
    wait: "Veuillez attendre que les autres participants soient prêts",
    start: "Lancer le jeu"
  },

  steps: {
    bufferSetup: "Paramétrage du buffer",
    clientOrder: "Commandes client",
    clientShipment: "Expéditions client",
    supplierShimpentWaiting: "En attente des livraisons",
    board: "Tableau de bord",
    supplierShipments: "Livraisons fournisseur",
    supplierOrders: "Commandes fournisseur",
    productionBatch: "Lancement en production",
    productionShipments: "Réception de la production",
    startNewWeek: "Démarrer une nouvelle semaine",
    youCanStartNewWeek: "Vous pouvez démarrer une nouvelle semaine",
    inProgressProduction: "Production en cours",
    flowEquationCalc: "Calcul de l'équation de flux",
    clientOrderTitleMessage: "Vous avez reçu une commande client"
  },

  clientsShimpents: {
    chooseQuantity: "Veuillez saisir vos livraisons",
    notMax: "Veuillez livrer au maximum de vos capacités",
    remains: "Reste à livrer : ",
    ok : "Valider les expéditions",
    shipmentsResume: "Vous avez livré {nbr} unité(s) à votre client | Vous avez livré {nbr} unité(s) à vos clients",
    remainResume: "Malheureusement vous avez un reste à livrer de {nbr} unité | Malheureusement vous avez un reste à livrer de {nbr} unités"
  },

  board: {
    cantOrder: "Vous ne pouvez pas commander pour le moment",
    cantProduce: "Vous ne pouvez pas lancer de production pour le moment"
  },

  suppliersShipments: {
    shipments: "Livraisons",
    production: "Vous avez produit {nbr} unité | Vous avez produit {nbr} unités",
    getShipments: "Réceptionner",
    waitShipment: "Veuillez attendre les livraisons",
    stockChange: "Votre stock passe à {nbr} unité | Votre stock passe à {nbr} unités",
    stockChangeTitle: "Actualisation de votre stock"
  },

  suppliersOrders: {
    maxOrder: "Quantité maximum ",
    ordersTo: "Commandes",
    remainsAlert: "Pour rappel, vous n'avez pas réussi à honorer vos commandes clients !",
    production: "Qté à lancer",
    orders: "Commandes",
    ok : "Valider les commandes",
    okProduction: "Valider les lancements en production"
  },

  stats: {
    suppliersRemains: "Reste à livrer fournisseur",
    buffers: "Buffers",
    resume: "Synthèse",
    orders: "Commandes",
    stock: "Stock",
    remains: "Ruptures",
    cost: "Coûts",
    stockDelay: "Stock et ruptures",
    companies: "Maillons",
    red: "Zone rouge",
    yellow: "Zone jaune",
    green: "Zone verte",
    flowEquation: "Equation de flux"
  },

  dd: {
    cmj: "Consommation moyenne journalière",
    leadTime: "Délai",
    variabilityFactor: "Facteur de variabilité",
    delayFactor: "Facteur de délai",
    availableStock: "Stock disponible",
    clientsRemains: "Reste à livrer clients",
    suppliersRemains: "Reste à livre fournisseurs",
    AverageStockLevelTarget: "Stock moyen théorique cible",
    falseOrder: "Vous n'avez pas commandé la bonne quantité",
    applyAutoCmj: "Appliquer automatiquement la CMJ calculée",
    calculatedCMJ: "CMJ calculé",
    bufferWeekExplanation: `L’équation de flux et le niveau de stock sont relevé à 3 moments clés de la semaine
    1er point : après reception commande client
    2eme point : après livraison vers client(s)
    3eme point : après reception et commande fournisseur`
  },

  debrief: {
    resume: {
      name: "Nom",
      level: "Rang",
      resume: "Synthèse",
      averageOrderQuantity: "Moyenne de la demande vers le fournisseur",
      averageRequestQuantity: "Moyenne de la demande du client",
      range: "Etendue de la demande",
      otd: "Ponctualité",
      delaysDepth: "Profondeur des retards",
      averageStock: "Stock moyen",
      stockCost: "Coût de stockage",
      delayCost: "Coût des ruptures",
      cost: "Coût total",
    }
  },

  user : {
    noParties : 'Aucune partie ne correspond à ce code et ce compte',
    falseTrainningKey : 'Clé formateur incorrect',
    welcome : "Bienvenue dans la partie ",
    noMorePlace : "Il n'y a plus de place dans la partie",
    notOpen: "La partie n'est pas ouverte",
    logoutConfirmation: "Êtes vous sûr de vouloir quitter la partie ?",
    sessionExpired: "Votre session a expiré, merci de vous reconnecter"
  },

  store : {
    error : "Erreur : "
  }
}